<div class="sidebar-wrapper">
          <ul class="nav">
              <!-- <li routerLinkActive="active" *ngFor="let menuitem of menuItems"> -->
                  <!-- If it is a single link -->
                  <!-- <a [routerLink]="[menuitem.menuLink]" *ngIf="menuitem.pmenuId === 0 && menuitem.menuLink" (click)="changeMenuName(menuitem.menuName)">
                      <i class="{{menuitem.icon}}"></i>
                      <p>{{menuitem.menuName}}</p>
                  </a> -->
  
                  <!-- If it has a submenu -->
                  <!-- <a data-bs-toggle="collapse" [attr.href]="'#collapse-' + menuitem.menuId" role="button" 
                     aria-expanded="false" [attr.aria-controls]="'collapse-' + menuitem.menuId" 
                     *ngIf="menuitem.pmenuId === 0 && !menuitem.menuLink">
                      <i class="{{menuitem.icon}}"></i>
                      <p>{{menuitem.menuName}}<b class="caret"></b></p>
                  </a> -->
  
                  <!-- Display the submenu items -->
                  <!-- <div [id]="'collapse-' + menuitem.menuId" class="collapse" [attr.aria-labelledby]="'heading-' + menuitem.menuId">
                      <ul class="nav">
                          <li routerLinkActive="active" *ngFor="let subMenu of subMenus[menuitem.menuId] || []">
                              <a [routerLink]="[subMenu.menuLink]" (click)="changeMenuName(subMenu.menuName)">
                                  <span class="sidebar-mini"><i class="{{subMenu.icon}}"></i></span>
                                  <span class="sidebar-normal">{{subMenu.menuName}}</span>
                              </a>
                          </li>
                      </ul>
                  </div>
              </li> -->
              <!-- ----------------------------------------NEW MENU---------------------------------------------- -->
  
              <ng-container *ngTemplateOutlet="menuLevel; context: { $implicit: rootItems, level: 0 }"></ng-container>

              <ng-template #menuLevel let-items let-level="level">
                <li *ngFor="let menuitem of items; trackBy: trackByNodeId"
                    [class.submenu-item]="level > 0">

                    <!-- Has children and NO menuLink (collapsible) -->
                    <a class="menu-link" role="button"
                       *ngIf="hasChildren(menuitem.nodeId) && !menuitem.nodeInfo.menuLink"
                       [attr.aria-expanded]="isExpanded(menuitem.nodeId)"
                       (click)="toggleCollapse(menuitem.nodeId, $event)">
                        <ng-container *ngTemplateOutlet="itemBody; context: { $implicit: menuitem, level: level }"></ng-container>
                    </a>

                    <!-- Has children AND a menuLink (navigates and toggles) -->
                    <a class="menu-link parent-with-link"
                       *ngIf="hasChildren(menuitem.nodeId) && menuitem.nodeInfo.menuLink"
                       [routerLink]="[menuitem.nodeInfo.menuLink]"
                       [queryParams]="menuitem.nodeInfo.queryParams"
                       routerLinkActive="active"
                       [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'exact', matrixParams: 'ignored', fragment: 'ignored' }"
                       [attr.aria-expanded]="isExpanded(menuitem.nodeId)"
                       (click)="changeMenuName(menuitem.nodeName); toggleNode(menuitem.nodeId)">
                        <ng-container *ngTemplateOutlet="itemBody; context: { $implicit: menuitem, level: level }"></ng-container>
                    </a>

                    <!-- Leaf link -->
                    <a class="menu-link"
                       *ngIf="!hasChildren(menuitem.nodeId) && menuitem.nodeInfo.menuLink"
                       [routerLink]="[menuitem.nodeInfo.menuLink]"
                       [queryParams]="menuitem.nodeInfo.queryParams"
                       routerLinkActive="active"
                       [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'exact', matrixParams: 'ignored', fragment: 'ignored' }"
                       (click)="changeMenuName(menuitem.nodeName)">
                        <ng-container *ngTemplateOutlet="itemBody; context: { $implicit: menuitem, level: level }"></ng-container>
                    </a>

                    <!-- Children (recursive) -->
                    <div *ngIf="hasChildren(menuitem.nodeId)"
                         [id]="'collapse-' + menuitem.nodeId" class="collapse"
                         [class.show]="isExpanded(menuitem.nodeId)"
                         [attr.aria-labelledby]="'heading-' + menuitem.nodeId">
                        <div class="grey-line"></div>
                        <ul class="nav submenu-list" [attr.data-level]="level + 1">
                            <ng-container *ngTemplateOutlet="menuLevel; context: { $implicit: subMenus[menuitem.nodeId], level: level + 1 }"></ng-container>
                        </ul>
                    </div>
                </li>
              </ng-template>

              <ng-template #itemBody let-menuitem let-level="level">
                  <ng-container *ngIf="menuitem.nodeInfo.icon">
                      <img class="menu-icon menu-icon-normal" [src]="'assets/icons/' + menuitem.nodeInfo.icon + '.svg'" alt="{{menuitem.nodeName}} icon" />
                      <img class="menu-icon menu-icon-active" [src]="'assets/icons/' + menuitem.nodeInfo.icon + '-active.svg'" alt="{{menuitem.nodeName}} icon" />
                  </ng-container>
                  <span [class.menu-text]="level === 0" [class.sidebar-normal]="level > 0">{{menuitem.nodeName}}</span>
              </ng-template>
              <!-- ---------------------------------------------------------------------------------------------------------------------------- -->
              <!-- <li>
                  <a href="https://www.google.com/">
                      <i class="pe-7s-study"></i>
                      <p>Documentation</p>
                  </a>
              </li> -->
          </ul>
  </div>
  
  <!-- Fixed Bottom Container for Desktop -->
  <div *ngIf="isNotMobileMenu()" class="fixed-bottom-container">
      <!-- Environment Selector -->
      <div ngbDropdown class="user fixed-bottom-user" placement="top-start" autoClose="outside">
          <button class="bottom-user" ngbDropdownToggle type="button">
              <svg class="global-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="currentColor" stroke-width="2"/>
              </svg>
              <span class="environment-text">{{selectedEnvironment}}</span>
              <b class="environment-arrow">&#x2304;</b>
          </button>
          <div ngbDropdownMenu class="user-menu-dropdown">
              <button ngbDropdownItem 
                      class="user-menu-item" 
                      [class.active]="selectedEnvironment === EnvironmentOpt.Sandbox"
                      (click)="selectEnvironment(EnvironmentOpt.Sandbox)">
                  Sandbox
              </button>
              <!-- <button ngbDropdownItem 
                      class="user-menu-item" 
                      [class.active]="selectedEnvironment === EnvironmentOpt.Production"
                      (click)="selectEnvironment(EnvironmentOpt.Production)">
                  Production
              </button> -->
          </div>
      </div>
      
      <!-- User Profile -->
      <div ngbDropdown class="user fixed-bottom-user" placement="top-start" autoClose="outside">
          <button class="bottom-user" ngbDropdownToggle type="button">
              <div class="photo">
                  <img src="../assets/img/profileLogo.png" />
              </div>
              <div class="user-profile-link">
                  <div class="user-info">
                      <div class="user-name">{{userName || 'User'}}</div>
                      <div class="user-role">{{userRole || 'Developer'}}</div>
                  </div>
              </div>
              <b class="ellipsis">&#x2304;</b>
          </button>
          <div ngbDropdownMenu class="user-menu-dropdown">
              <button ngbDropdownItem class="user-menu-item" (click)="navigateToUserProfile()">
                  User Profile
              </button>
              <button ngbDropdownItem class="user-menu-item" (click)="logout()">
                  Sign Out
              </button>
          </div>
      </div>
  </div>
  
  <!-- Fixed Bottom Container for Mobile -->
  <div *ngIf="!isNotMobileMenu()" class="fixed-bottom-container">
      <!-- Environment Selector -->
      <div ngbDropdown class="user fixed-bottom-user" placement="top-start" autoClose="outside">
          <button class="bottom-user" ngbDropdownToggle type="button">
            <svg class="global-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="currentColor" stroke-width="2"/>
            </svg>
              <span class="environment-text">{{selectedEnvironment}}</span>
              <b class="ellipsis">&#x2304;</b>
          </button>
          <div ngbDropdownMenu class="user-menu-dropdown">
              <button ngbDropdownItem 
                      class="user-menu-item" 
                      [class.active]="selectedEnvironment === EnvironmentOpt.Sandbox"
                      (click)="selectEnvironment(EnvironmentOpt.Sandbox)">
                  Sandbox
              </button>
              <!-- <button ngbDropdownItem 
                      class="user-menu-item" 
                      [class.active]="selectedEnvironment === EnvironmentOpt.Production"
                      (click)="selectEnvironment(EnvironmentOpt.Production)">
                  Production
              </button> -->
          </div>
      </div>
      
      <!-- User Profile -->
      <div ngbDropdown class="user fixed-bottom-user" placement="top-start" autoClose="outside">
          <button class="bottom-user" ngbDropdownToggle type="button">
              <div class="photo">
                  <img src="../assets/img/profileLogo.png" />
              </div>
              <div class="user-profile-link">
                  <div class="user-info">
                      <div class="user-name">{{userName || 'User'}}</div>
                      <div class="user-role">{{userRole || 'Developer'}}</div>
                  </div>
              </div>
              <b class="ellipsis">&#x2304;</b>
          </button>
          <div ngbDropdownMenu class="user-menu-dropdown">
              <button ngbDropdownItem class="user-menu-item" (click)="navigateToUserProfile()">
                  User Profile
              </button>
              <button ngbDropdownItem class="user-menu-item" (click)="logout()">
                  Sign Out
              </button>
          </div>
      </div>
  </div>
  